import { Box, CircularProgress, Collapse, Typography } from "@mui/material";
import { useGlobalContext } from "../../../context/global";
import ComplexFilterWidget from "../../../components/Filter/ComplexFilterWidget";
import { useTopXDataConfig } from "../../../components/Filter/FilterData/quadrantFilter";
import {
  customDateToTimePeriod,
  FILTER_LAST_7_14_DAYS_OPTIONS,
  getFilterConfigForCampaignAbo,
  timePeriodToCustomDate,
  useFilterFieldsBootstrap,
} from "../../../components/Filter/filterQuadrantUtils";
import { ABO_COLORS, sectionTitleSx } from "../lib/campaignAboStyles";

const CAMPAIGN_ABO_DAYS_OPTIONS = FILTER_LAST_7_14_DAYS_OPTIONS.filter(
  (option) => option.value !== "yesterday" && option.value !== "last_3d"
);

export default function CampaignAboPerfFilterPanel({
  open,
  slotLocalId,
  filterModuleFilters,
  onOutput,
  timePeriod,
  onTimePeriodChange,
  isFilterApplied,
  onAppliedCallback,
}) {
  const { clientId, selectedPlatform } = useGlobalContext();
  const userPlatform = selectedPlatform ?? "amazon";
  const TopXDataConfig = useTopXDataConfig();
  const { ready: fieldsReady, loading: fieldsLoading } = useFilterFieldsBootstrap(
    clientId,
    userPlatform
  );

  const selectedDay =
    CAMPAIGN_ABO_DAYS_OPTIONS.find(
      (option) => option.value === timePeriodToCustomDate(timePeriod)
    ) ?? CAMPAIGN_ABO_DAYS_OPTIONS[0];

  const handleSelectedDay = (day) => {
    const value = day?.value ?? day;
    if (value) onTimePeriodChange(customDateToTimePeriod(value));
  };

  if (!open) return null;

  const showLoader = fieldsLoading || !fieldsReady;
  const filterConfig = getFilterConfigForCampaignAbo(userPlatform, TopXDataConfig);

  return (
    <Box
      sx={{
        mt: 2,
        border: `1px solid ${ABO_COLORS.border}`,
        borderRadius: 2.5,
        overflow: "hidden",
      }}
    >
      <Box sx={{ px: 2, py: 1.5, borderBottom: `1px solid ${ABO_COLORS.border}` }}>
        <Typography sx={{ ...sectionTitleSx, fontSize: "0.9375rem" }}>
          Performance filters
        </Typography>
      </Box>
      <Collapse in={open}>
        <Box sx={{ p: 0, minHeight: showLoader ? 160 : 120 }}>
          {showLoader ? (
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 1.5,
                py: 5,
              }}
            >
              <CircularProgress size={28} thickness={4} />
              <Typography sx={{ fontSize: "0.8125rem", fontWeight: 500, color: ABO_COLORS.muted }}>
                Loading filters…
              </Typography>
            </Box>
          ) : (
            <ComplexFilterWidget
              key={slotLocalId ? `campaign_abo_perf_${slotLocalId}` : "campaign_abo_perf"}
              config={filterConfig}
              campaignFilter={false}
              filters={filterModuleFilters ?? {}}
              output={onOutput}
              prefixMember=""
              type="page"
              page="campaign-abo"
              sidebar
              default="metrics"
              narrowFilters={false}
              showDays
              daysOptions={CAMPAIGN_ABO_DAYS_OPTIONS}
              selectedDay={selectedDay}
              handleSelectedDay={handleSelectedDay}
              isAppliedCallback={onAppliedCallback}
              calloutTitle="Select your filters"
              calloutContent="+ Add Filter"
              hideFilterSummary={true}
              summaryStyles={{ border: "none" }}
              showDimensionFilter={false}
              setShowPopupModal={() => {}}
              showPopupModal={open}
              id={slotLocalId ? `campaign_abo_${slotLocalId}` : "campaign_abo"}
            />
          )}
        </Box>
      </Collapse>
      {isFilterApplied && !showLoader && (
        <Box sx={{ px: 2, py: 1.25, borderTop: `1px solid ${ABO_COLORS.border}` }}>
          <Typography variant="caption" sx={{ fontWeight: 600, color: "primary.main", fontSize: "0.8125rem" }}>
            Filters applied for this duration
          </Typography>
        </Box>
      )}
    </Box>
  );
}
